import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type { WebChannelAnalyticsConfig } from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class AnalyticsService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  /**
   * Публичная конфигурация веб-аналитики и CMP текущей витрины
   */
  getConfig(): Promise<WebChannelAnalyticsConfig> {
    return this.api.analyticsConfig(this.appConfig.host)
  }
}
